import { h } from 'preact';
import { SymbolLookup } from '@cube/finance-blocks';
import { DeviceVariance, containerSize } from '@cube/blocks';
import { QuoteHeader } from '../quote-header';
import Container from '../container';
import cx from 'classnames';
import style from './style';

function routeToSymbol(quote) {
	window.location = `/finance/category/stockdetail/symbol/${quote.UniqueSymbol}`;
}

const SymbolLookupWidget = ({ width, theme }) => (
	<DeviceVariance
		phone={
			<SymbolLookup
				class={style.symbolLookupWidget}
				onSymbolSelect={routeToSymbol}
				trackingSource="symbol-lookup-widget"
				trackingZone="finance-components"
			/>
		}
		tablet={
			<Container>
				<QuoteHeader />
				<SymbolLookup
					class={cx(style.symbolLookupWidget, style.tablet, width >= 768 && style.wide)}
					onSymbolSelect={routeToSymbol}
					trackingSource="symbol-lookup-widget"
					trackingZone="finance-components"
				/>
			</Container>
		}
		desktop={
			<Container>
				<QuoteHeader />
				<SymbolLookup
					class={cx(style.symbolLookupWidget, style.desktop)}
					onSymbolSelect={routeToSymbol}
					trackingSource="symbol-lookup-widget"
					trackingZone="finance-components"
					theme={theme}
				/>
			</Container>
		}
	/>
);

export default containerSize({ height: false })(SymbolLookupWidget);
